<template>
    <div @click="changeType" :class="'outer'+type">
        <audio
            ref="audio"
            preload="auto"
            :src="audioObj.url"
            @timeupdate="onTimeupdate"
            @ended="onEnded"
            @loadeddata="setCur"
        ></audio>
        <div :class="'inner'+type">
            <music  class="musicbox" v-show="!type"></music>
            <div class="control" v-show="type">
                <div class="left">
                    <p class="title">{{audioObj.title}}</p>
                    <p class="time">{{maxTime-currentTime | formatSecond}}</p>
                </div>
                <div class="right">
                    <my-progress radius="0.94rem" :percent="Math.min(1, currentTime/(maxTime-1)) || 0">
                        <div class="btn" 
                            :class="[isplay?'off':'on']" 
                            @click.stop="toggleplay()">
                        </div>
                    </my-progress>
                </div>
            </div>
            <div class="triangle">

            </div>
        </div>
    </div>
</template>

<script>
import music from './music'
import myProgress from './progress'
//时间转换
const transTime = value => {
	let time = "";
	let h = parseInt(value / 3600);
	value %= 3600;
	let m = parseInt(value / 60);
	let s = parseInt(value % 60);
	if (h > 0) {
		time = formatTime(h + ":" + m + ":" + s);
	} else {
		time = formatTime(m + ":" + s);
	}
	return time;
};

//时间格式化
const formatTime = value => {
	let time = "";
	// 将字符串分割成数组
	let s = value.split(":");
	let i = 0;
	for (; i < s.length - 1; i++) {
		time += s[i].length == 1 ? "0" + s[i] : s[i];
		time += ":";
	}
	time += s[i].length == 1 ? "0" + s[i] : s[i];
	return time;
};
    export default {
        name: '',
        components: {
            music,
            myProgress
        },
        watch: {
            isplay(value) {
                this.$store.commit('setPlayerPlay', value)
            }
        },
        data() {
            return {
                isplay: false,
                type: 0, //0缩小状态1展开状态
                currentTime: 0,
                maxTime: 0
            }
        },
        filters: {
            // 将整数转化成时分秒
            formatSecond(second = 0) {
                return transTime(second);
            }
        },
        computed: {
            audioObj() {
                return this.$store.state.audioObj;
            },
            playerStatus() {
                return this.$store.state.playerStatus
            }
        },
        mounted() {
            let vm = this
            //兼容微信端不能自动播放
            if(window.WeixinJSBridge){
                    WeixinJSBridge.invoke('getNetworkType', {}, function(e) {
                        vm.play();
                        vm.isplay = true
                    }, false);
                }else{
                    document.addEventListener("WeixinJSBridgeReady", function() {
                    WeixinJSBridge.invoke('getNetworkType', {}, function(e) {
                        vm.play();
                        vm.isplay = true
                    });
                }, false);
            }
            //正常可以播放就播放
            vm.play();
            vm.isplay = true
            
        },
        beforeDestroy() {
            this.pause()
        },
        methods: {

            setCur() {
                this.$refs.audio.currentTime = this.audioObj.cur;
            },
            onTimeupdate(res) {
                this.currentTime = res.target.currentTime;
                this.maxTime = parseInt(res.target.duration);
                // console.log(this.$refs.audio.currentTime)
            },
            onEnded() {
                this.currentTime = 0;
                this.maxTime = 0
                this.$store.commit('setPlayerType', false)
            },
            play() {
                this.isplay = true
                this.$refs.audio.play();
            },
            pause() {
                this.isplay = false
			    this.$refs.audio.pause();
            },
            changeType() {
                if(this.type == 0) {
                    this.type = 1
                }else {
                    this.type = 0
                }
            },
            toggleplay() {
			    this.isplay ? this.pause() : this.play();
            },
            setSmall() {
                this.type = 0
            }
        }
    }
</script>

<style lang="scss" scoped>
        @import "../../static/css/mixin.scss";
        .outer0{
            width: 121px;
            height: 78px;
        }
        .outer1{
            width: 351px;
            height: 120px;
        }
        .inner0{
            width: 121px;
            height: 78px;
            background: rgba($color: #FFFFFF, $alpha: 0.7);
            box-shadow:0px 2px 4px 0px rgba(29,48,77,0.47);
            border-top-left-radius: 39px;
            border-bottom-left-radius: 39px;
            z-index: 200;
            padding: 22px 0;
            position: absolute;
        }
        .inner1{
            width: 351px;
            height: 120px;
            z-index: 200;
            background: rgba($color: #FFFFFF, $alpha: 1);
            box-shadow:0px 2px 4px 0px rgba(29,48,77,0.47);
            border-radius: 6px;
            padding: 25px;
            position: absolute;
            right: 14px;
            .triangle{
                width: 0;
                height: 0;
                border: 24px solid;
                border-color: transparent;
                border-left-color: #FFFFFF;
                position: absolute;
                right: -40px;
                top: 20px;
                // box-shadow:0px 2px 4px 0px rgba(29,48,77,0.47);
            }
        }
        .musicbox{
            width: 59px;
            height: 34px;
            margin-left: 42px;
        }
        .control{
            display: flex;
            justify-content: space-between;
            .left{
                // flex: 1;
                // background: yellow;
                width: 216px;
                height: 70px;
                .title{
                    font-size:30px;
                    font-weight:400;
                    color:rgba(24,24,24,1);
                    line-height: 40px;
			        @include ellipsis();
                }
                .time{
                    line-height: 30px;
                    font-size:24px;
                    font-weight:400;
                    color:rgba(160,159,159,1);
                }
            }
            .right{
                width: 70px;
                height: 70px;
                .btn{
                    width: 0.84rem;
                    height: 0.84rem;
                    border-radius: 50%;
                    position: absolute;
                    top: 0.05rem;
                    left: 0.05rem;
				    transition: background-image 0.2s ease-out 0s;
                    &.on{
                        background: url('../../static/img/bofang.png') no-repeat center center;
                        background-size: 100% 100%;
                    }
                    &.off{
                        background: url('../../static/img/zanting.png') no-repeat center center;
                        background-size: 100% 100%;
                    }
                }
            }
        }
</style>


// WEBPACK FOOTER //
// src/components/player.vue